module.exports = __webpack_public_path__ + "static/media/planes_new.e2949456.jpeg";